import { render, staticRenderFns } from "./TableInformation1.vue?vue&type=template&id=384ca9d4"
import script from "./TableInformation1.vue?vue&type=script&lang=js"
export * from "./TableInformation1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports